import type { GetPlansApiQuery } from "@/Modules/Models/Api/Plan";
import { ONBOARDING_SOURCE } from "@/Modules/Models/Domain/Plan";

import { getPlans, getExtraPlans } from "@/Services/TherapyApi/Plans";

import PlanTransformer from "@/Modules/Transformers/Plan";

import usePlanStore from "@/Modules/Plan/Store";

import { log } from "@/Utils/Debug";

async function fetchPlansAH(userId: string, comeFromOnboarding: boolean, isExtra: boolean = false) {
  const planStore = usePlanStore();

  planStore.loading = true;

  try {
    if (!isExtra) {
      const getPlansApiQuery: GetPlansApiQuery = {
        page_size: 100,
        user_uuid: userId,
        source: comeFromOnboarding ? ONBOARDING_SOURCE : undefined,
      };

      const planApiResponse = await getPlans(getPlansApiQuery);

      planStore.plans = planApiResponse.body.map(PlanTransformer.toDomain);
    } else {
      const planApiResponse = await getExtraPlans();

      planStore.plans = planApiResponse.map(PlanTransformer.toDomain);
    }
  } catch (error) {
    log("Error fetch plans", error);
  } finally {
    planStore.loading = false;
  }

  return planStore.plans;
}
export default fetchPlansAH;
